export default "__VITE_ASSET__jjCLbSrg__"